import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { AlertService } from '@shared/components/alert/alert.service';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-form-acp-add',
  templateUrl: './form-acp-add.component.html',
  styleUrls: ['./form-acp-add.component.scss']
})
export class FormAcpAddComponent implements OnInit {
  @Input() branch_id;
  form: FormGroup;
  @Output() actionChanges   = new EventEmitter<any>();
  branches: any             = [];
  accountData: any          = [];
  costData: any             = [];
  users:any                 = [];
  myDate: any               = new Date();
  showfield: boolean        = false;
  filename: any             = this.lang.transform('lang_select_files');
  isFile: boolean           = false;
  lang_key                  = localStorage.getItem('lang_key') || 'en';
  markstatus:boolean        = false;
  reviewstatus:boolean      = false;
  submitted:boolean         = false;
  constructor(public ds:DataService,public datePipe: DatePipe,public router : Router, public ls:LocalStorage ,public lang:LanguagePipe, public spinner:PreloaderService, public fb:FormBuilder, public alert:AlertService, public dialog:MatDialog, public modalService: BsModalService,) { }
  ngOnInit(): void {
    this.myDate = new Date(this.datePipe.transform(this.myDate, 'yyyy-MM-dd'));
    this.buildform();
    this.get_account_managers();
    this.formControlValueChanged();
  }
  public get_account_managers() {
    this.form.get('signature[C][title]').setValue(this.lang.transform('lang_account_writer'));
    this.form.get('signature[C][title]').disable();
    this.form.get('signature[C][user_id]').setValue(this.ls.getItem('user_id'));
    this.form.get('signature[C][user_id]').disable();
    this.users = [];
    this.ds.getActionByUrl([], 'form/FORM_ACR/get_manager_users').subscribe(res => {
      this.spinner.hide();
      if(res.status) {
        this.users = res.records;
        if(res.records.length >= 2) {
          this.form.get('signature[A][title]').setValue(this.lang.transform('lang_account_manager'));
          this.form.get('signature[A][title]').disable();
          this.form.get('signature[A][user_id]').setValue(res.records[0]['value']);
          this.form.get('signature[A][user_id]').disable();
        }
        if(res.records.length >= 3) {
          this.form.get('signature[B][title]').setValue(this.lang.transform('lang_account_manager'));
          this.form.get('signature[B][title]').disable();
          this.form.get('signature[B][user_id]').setValue(res.records[1]['value']);
          this.form.get('signature[B][user_id]').disable();
        }
        if(res.records.length >= 3) {
          let ids = [];
          res.records.forEach((v, k) => {
            if(k > 1 && v.value != this.ls.getItem('user_id')) {
              ids.push(v.value);
            }
          });
          if(ids.length > 0 ) {
            this.markstatus = true;
            this.form.get('needMark').setValue('1');
            this.form.get('marks').setValue(ids);
          }
        }
      }
    }, error => {
      this.spinner.hide();
    })
  }
  public buildform() {
    this.form = new FormGroup({
      branch_id                             : new FormControl(this.branch_id, [Validators.required]),
      payment_receipt_date                  : new FormControl(this.myDate, [Validators.required]),
      payment_receipt_to_from               : new FormControl('', [Validators.required]),
      payment_receipt_mode                  : new FormControl('', [Validators.required]),
      payment_receipt_debit_account_id      : new FormControl(null, [Validators.required]),
      payment_receipt_debit_cost_id         : new FormControl(null),
      payment_receipt_credit_account_id     : new FormControl(null, [Validators.required]),
      payment_receipt_credit_cost_id        : new FormControl(null),
      payment_receipt_amount                : new FormControl('', [Validators.required]),
      payment_receipt_document_number       : new FormControl(''),
      payment_receipt_document_date         : new FormControl(''),
      payment_receipt_bank_name             : new FormControl(''),
      payment_receipt_notes                 : new FormControl(''),
      payment_receipt_description           : new FormControl('', [Validators.required]),
      payment_receipt_attachment            : new FormControl(''),
      subject                               : new FormControl(this.lang.transform('lang_payments'), [Validators.required]),
      transaction_from                      : new FormControl(this.branch_id, [Validators.required]),
      transaction_to                        : new FormControl(this.branch_id, [Validators.required]),
      'signature[A][title]'                 : new FormControl('', [Validators.required]),
      'signature[A][user_id]'               : new FormControl(null, [Validators.required]),
      'signature[B][title]'                 : new FormControl('', [Validators.required]),
      'signature[B][user_id]'               : new FormControl(null, [Validators.required]),
      'signature[C][title]'                 : new FormControl('', [Validators.required]),
      'signature[C][user_id]'               : new FormControl(null, [Validators.required]),
      needMark                              : new FormControl('0', [Validators.required]),
      marks                                 : new FormControl(null),
      needReview                            : new FormControl('0', [Validators.required]),
      reviews                               : new FormControl(null),
    });
  }
  public formControlValueChanged() {
    const payment_receipt_document_number   = this.form.get('payment_receipt_document_number');
    const payment_receipt_document_date     = this.form.get('payment_receipt_document_date');
    const payment_receipt_bank_name         = this.form.get('payment_receipt_bank_name');
    const payment_receipt_attachment        = this.form.get('payment_receipt_attachment');
    this.form.get('payment_receipt_mode').valueChanges.subscribe(
      (mode: string) => {
        this.showfield = false;
        if (mode !== 'cash') {
          this.showfield = true;
          payment_receipt_document_number.setValidators([Validators.required]);
          payment_receipt_document_date.setValidators([Validators.required]);
          payment_receipt_bank_name.setValidators([Validators.required]);
          payment_receipt_attachment.setValidators([Validators.required]);
        } else {
          payment_receipt_document_number.clearValidators();
          payment_receipt_document_date.clearValidators();
          payment_receipt_bank_name.clearValidators();
          payment_receipt_attachment.clearValidators();
        }
        payment_receipt_document_number.updateValueAndValidity();
        payment_receipt_document_date.updateValueAndValidity();
        payment_receipt_bank_name.updateValueAndValidity();
        payment_receipt_attachment.updateValueAndValidity();
        payment_receipt_document_number.setValue('');
        payment_receipt_document_date.setValue('');
        payment_receipt_bank_name.setValue('');
        payment_receipt_attachment.setValue([]);
        this.removeFile();
      });
  }
  public uploadFile(event) {
    if (
      event.target.files[0] &&
      event.target.files[0] !== undefined &&
      event.target.files[0].name
    ) {
      const fileid = event.target.files[0];
      this.filename = fileid.name;
      this.isFile = true;
      this.form.get("payment_receipt_attachment").setValue(fileid, { emitEvent: true });
    } else {
      this.isFile = false;
      this.form.get("payment_receipt_attachment").setValue('');
      this.filename = this.lang.transform('lang_select_files');
    }
  }
  public removeFile() {
    this.isFile     = false;
    this.form.get("payment_receipt_attachment").setValue('');
    this.filename   = this.lang.transform('lang_select_files');
  }
  public searchAccounts(key) {
    this.accountData = [];
    let param = new FormData();
    param.append('branch_id',   this.form.get('branch_id').value);
    param.append('search_text', key.term);
    if(this.form.get('branch_id').value && key.term && key.term != undefined) {
      this.ds.postActionByUrl(param, "form/FORM_ACP/search_account_master").subscribe(data => {
        if (data.status) {
          this.accountData = data.records;
        }
      });
    }
  }
  public searchCosts(key) {
    this.costData   = [];
    let param       = new FormData();
    param.append('branch_id', this.form.get('branch_id').value);
    param.append('search_text', key.term);
    if(this.form.get('branch_id').value && key.term && key.term != undefined) {
      this.ds.postActionByUrl(param, 'form/FORM_ACP/search_cost_center').subscribe(res => {
        if (res.status) {
          this.costData = res.records;
        }
      });
    }
  }
  public search_users(key) {
		this.users = [];
    if(key && key.term) {
      let param = new FormData();
      param.append('search', key.term);
      param.append('lang_key', this.lang_key);
      param.append('user_type_id', '1');
      this.ds.getActionByUrl(this.ds.formData2string(param), 'tc/getformuserslist').subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          this.users = res.list;
        }
      })
    }
	}
  public enable_field(field) {
		if (field == 'mark') {
      this.form.get('needMark').setValue('1');
		  this.form.get('marks').setValidators(Validators.required);
		  this.form.get('marks').updateValueAndValidity();
		  this.markstatus = true;
		} else if (field == 'review') {
      this.form.get('needReview').setValue('1');
		  this.form.get('reviews').setValidators(Validators.required);
		  this.form.get('reviews').updateValueAndValidity();
		  this.reviewstatus = true;
		}
    this.form.updateValueAndValidity();
	}
	public disable_field(field) {
		if (field == 'mark') {
      this.form.get('needMark').setValue('0');
			this.form.get('marks').setValue(null);
			this.form.get('marks').clearValidators();
			this.form.get('marks').updateValueAndValidity();
			this.markstatus = false;
		} else if (field == 'review') {
      this.form.get('needReview').setValue('0');
			this.form.get('reviews').setValue(null);
			this.form.get('reviews').clearValidators();
			this.form.get('reviews').updateValueAndValidity();
			this.reviewstatus = false;
		}
		this.form.updateValueAndValidity();
  }
  public create_payment() {
    this.spinner.show();
    this.ds.postActionByUrl(this.ds.json2formdata(this.form.value), 'form/FORM_ACP/cr/0').subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.form.reset();
        this.alert.success(this.lang.transform('lang_success'));
        this.form.reset();
        setTimeout(() => {
          this.router.navigate(['/transactions/'+res.url]);
        }, 1000);
      } else {
        this.alert.error(res.error);
      }
    }, error => {
      this.spinner.hide();
        this.alert.error((error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
    });
  }


}
